<template>
  <div>
    <div class="mask">s</div>
    <div class="contain">
      <van-nav-bar
        title="邀请亲友"
        left-arrow
        fixed
        :z-index="99"
        @click-left="onClickLeft"
        :border="false"
      />
      <div class="navBarSpace"></div>
      <div class="title">
        请逝者亲友 共同缅怀
        <span class="subTitle"
          >仅限逝者亲友扫码进馆，参与祭拜，留言寄托哀思</span
        >
      </div>
      <div class="method">
        <div class="nav">
          方法一
          <span class="text"> 长按海报发送朋友邀请加入</span>
        </div>
        <div class="img" v-if="path != ''">
          <!-- <img src="@/assets/images/hb.jpg" /> -->
          <img :src="path" />
        </div>
      </div>
      <div class="method">
        <div class="nav">
          方法二
          <span class="text"> 发送链接邀请亲友加入</span>
        </div>
        <div class="spance"></div>
        <van-button @click="onCopy" type="primary" size="large"
          >发送链接邀请亲朋加入</van-button
        >
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      id: "",
      path: "",
    };
  },
  methods: {
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetMemorialHallQrcode",
          id: this.id,
        })
        .then((res) => {
          //console.log(res, "xxxxxxxxx");
          if (res.length > 0) {
            that.path = res[0].Path;
          }
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onCopy() {
      this.$copyText(
        location.protocol + "//" + location.host + "/MemorialHall?id=" + this.id
      ).then(
        function(e) {
          //alert('Copied')
          Toast("复制成功！");
          console.log(e);
        },
        function(e) {
          //alert('Can not copy')
          Toast("复制权限不够！");
          console.log(e);
        }
      );
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.init();
  }
};
</script>

<style lang="less" scoped>
.contain {
  height: 100%;
  width: 100%;
  color: white;
  padding: 10px 30px 10px 30px;
  position: relative;
}

.mask {
  background-color: black;
    opacity: 0.7;
    width: 100%;
    height: 100%;
    position: fixed;
}

.title {
  display: flex;
  flex-direction: column;
  font-size: 19px;
  font-weight: 700;
  margin-bottom: 10px;
  .subTitle {
    font-size: 14px;
    color: #8d8a86;
  }
}
.method {
  .nav {
    font-size: 17px;
    color: #0ff064;
    .text {
      color: white;
    }
  }
  .img {
    padding: 10px 20px 10px 20px;
  }
  .spance {
    margin-top: 10px;
  }
}
</style>
